import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Label, Textarea } from 'idsk-react-components';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import { cancelMpk } from '../../../client/pracovnyKrok/mpkClient';
import MpkCancelButtons from './component/MpkCancelButtons';
import './mpkCancel.scss';
import LegislativnyMaterialDetail, { AKT_EU } from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { cancelMpkByAdmin } from '../../../client/admin/mpkCancelClient';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
  isAdmin?: boolean;
}

const MpkCancel = ({ materialDetail, isAdmin = false }: Props): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const [dovodZrusenia, setDovodZrusenia] = useState<string>();

  const {
    wrapClient: mpkClient,
    status: mpkStatus,
  } = useClient(isAdmin ? cancelMpkByAdmin : cancelMpk);

  const handleMpkCancel = async (): Promise<void> => {
    if (isAdmin) {
      await mpkClient(type, year, index, dovodZrusenia);
    } else {
      await mpkClient(type, year, index, pracovnyKrokId, dovodZrusenia);
    }
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="zrusenie-mpk">
      <Label className="zrusenie-mpk__label" htmlFor="dovodZrusenia">Dôvod zrušenia PK</Label>
      <div className="zrusenie-mpk__reason idsk-!-width-two-thirds">
        <Textarea
          name="dovodZrusenia"
          rows={5}
          maxLength={2048}
          showRemaining
          onChange={
            ({ target }) => {
              setDovodZrusenia(target.value);
              clearFieldErrorMessage('dovodZrusenia');
            }
          }
          error={getFieldErrorMessage('dovodZrusenia')}
        />
      </div>
      <MpkCancelButtons
        isAktEu={materialDetail.typ?.uuid === AKT_EU}
        onClick={handleMpkCancel}
        loading={mpkStatus.loading}
        isAdmin={isAdmin}
      />
    </div>
  );
};

export default MpkCancel;
